import { Component, inject, input } from "@angular/core";
import { DialogRef } from "@angular/cdk/dialog";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { Passkey } from "../../../_models/passkey.interface";

// Bestätigung vor dem Löschen eines Passkeys (siehe bentomax/hawk#596)
@Component({
  selector: "hawk-passkey-delete-dialog",
  standalone: true,
  imports: [FontAwesomeModule],
  template: `
    <div class="p-6 flex flex-col gap-4">
      <h2 class="text-lg font-bold">Passkey löschen</h2>
      <p>
        Soll der Passkey <strong>{{ passkey()?.name || "ohne Namen" }}</strong> wirklich gelöscht werden?
      </p>
      <p class="text-sm text-base-content/70">
        Mit diesem Passkey ist danach keine Anmeldung mehr möglich. Im Passwortmanager bzw. auf dem Gerät bleibt er
        gespeichert und kann dort zusätzlich entfernt werden. Die Anmeldung mit Passwort ist davon nicht betroffen.
      </p>
      <div class="bm-modal-action mt-2">
        <button type="button" class="bm-btn" (click)="dialogRef.close(false)">Abbrechen</button>
        <button type="button" class="bm-btn bm-btn-error" data-testid="confirm-delete" (click)="dialogRef.close(true)">
          <fa-icon [icon]="faTrash"></fa-icon>
          Löschen
        </button>
      </div>
    </div>
  `,
})
export class PasskeyDeleteDialogComponent {
  passkey = input<Passkey>();

  protected dialogRef = inject<DialogRef<boolean>>(DialogRef);
  protected readonly faTrash = faTrash;
}
